import { useEffect, useState, useRef } from 'react';
export const useOtpLockoutDuration = (otpStatus)=>{
    const [lockoutDuration, setLockoutDuration] = useState(0);
    const timeoutRef = useRef(null);
    useEffect(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (otpStatus) {
            const { lockoutEnd = 0 } = otpStatus;
            const nowTimestamp = Math.floor(Date.now() / 1000);
            const newLockoutDuration = Math.max(lockoutEnd - nowTimestamp, 0);
            setLockoutDuration(newLockoutDuration);
            if (newLockoutDuration > 0) {
                timeoutRef.current = setTimeout(()=>{
                    setLockoutDuration(0);
                }, newLockoutDuration * 1000);
            }
        }
        return ()=>{
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [
        otpStatus
    ]);
    return lockoutDuration;
};
